import type { ReactNode } from 'react';

import './list-page.css';

export interface ListPageLayoutProps {
  search: ReactNode;
  tabs: ReactNode;
  /** Null before the list has loaded. */
  countLabel: string | null;
  resultsId: string;
  children: ReactNode;
}

export function ListPageLayout({
  search,
  tabs,
  countLabel,
  resultsId,
  children,
}: ListPageLayoutProps) {
  return (
    <section className="nb-listpage">
      <div className="nb-listpage-bar">
        <div className="nb-listpage-search">{search}</div>
        <div className="nb-listpage-tabs">{tabs}</div>
        {countLabel && <span className="nb-listpage-count">{countLabel}</span>}
      </div>
      <div id={resultsId} role="tabpanel" className="nb-listpage-results">
        {children}
      </div>
    </section>
  );
}
